import ParentDashboardTypes from './parentDashboard.types';
import { getCoachDetails } from './parentDashboard.utils';
import { initialParentDashboardState } from '../initialState';

export const parentDashboardDetails = (
	state = initialParentDashboardState,
	action = {},
) => {
	switch (action.type) {
		case ParentDashboardTypes.ADD_CHILD_DETAILS.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case ParentDashboardTypes.GET_CHILDREN_LIST.SUCCESS:
			return Object.assign({}, state, {
				childrenList: action.payload,
			});
		case ParentDashboardTypes.GET_CHILDREN_LIST.FAILURE:
			return Object.assign({}, state, {
				childrenList: [],
			});
		case ParentDashboardTypes.SET_EDIT_CHILD_DETAILS:
			return Object.assign({}, state, {
				editChildDetails: { ...action.payload },
				showEditChild: true,
			});
		case ParentDashboardTypes.GET_CHILD_TOKEN.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case ParentDashboardTypes.UPDATE_PARENT_NAME.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case ParentDashboardTypes.SHOW_EDIT_CHILD:
			return Object.assign({}, state, { showEditChild: action.payload });
		case ParentDashboardTypes.SHOW_ADD_CHILD:
			return Object.assign({}, state, { showAddChild: action.payload });
		case ParentDashboardTypes.GET_CHILD_COURSE.SUCCESS:
			return Object.assign({}, state, { courses: { ...action.payload } });
		case ParentDashboardTypes.GET_PRODUCT_DETAILS_CHILD.SUCCESS:
			return Object.assign({}, state, { productDetail: { ...action.payload } });
		case ParentDashboardTypes.RESET_TOKEN:
			return Object.assign({}, state, { childToken: '' });
		case ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.SUCCESS:
			return Object.assign({}, state, {
				...getCoachDetails(action.payload),
			});
		case ParentDashboardTypes.SET_HAS_LICENSE:
			return Object.assign({}, state, { is_parentpurchased: action.payload });
		case ParentDashboardTypes.GENERATE_CHILD_REPORT.SUCCESS:
			return Object.assign({}, state, { reportUrl: action.payload });
		case ParentDashboardTypes.SET_ACTIVE_CHILD:
			return Object.assign({}, state, { activeChildId: action.payload });
		case ParentDashboardTypes.GET_CHILD_DETAILS.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		default:
			return state;
	}
};
